<template>
    <div class="inventory">
        <div class="inventory-banner">
            <el-form :model="formSearch" ref="dataForm" :rules="rules">
                <el-form-item prop="supplierName">
                    <el-autocomplete
                        v-model="formSearch.supplierName"
                        clearable
                        :fetch-suggestions="querySearchAsync"
                        placeholder="请输入供应商名称"
                        @select="handleSelect"
                        value-key="Name"
                    >
                        <template #prefix>
                            <ab-svg name="search"></ab-svg>
                        </template>
                    </el-autocomplete>

                </el-form-item>

                <el-form-item prop="sendEmail">
                    <el-input v-model="formSearch.sendEmail" placeholder="请输入接收邮箱" clearable>
                        <template #prefix>
                            <ab-svg name="email"></ab-svg>
                        </template>
                    </el-input>
                </el-form-item>
            </el-form>

            <div class="btn">
                <el-button type="primary" @click="inquire" :loading="loading"><ab-svg name="search"></ab-svg>查询</el-button>
            </div>

            <div class="word" @click="jump">查询记录<el-icon><ArrowRight /></el-icon></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'inventory',
    data() {
        let validatePass = (rule, value, callback)=>{
            if(!value){
                return callback(new Error("请输入邮箱"));
            }else if(!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)){
                return callback(new Error("请输入正确的邮箱格式"));
            }else{
                callback()
            }
        }
        return {
            loading: false,
            formSearch: {},
            rules: {
                supplierName: [
                    { required: true, message: '请输入供应商名称', trigger: 'change'}
                ],
                sendEmail: [
                    { required: true, validator: validatePass, trigger: 'change'}
                ],
            }
        }
    },
    methods:{
        querySearchAsync(queryString, cb){
            let params = Object.assign({}, {keyword: queryString || '中国'})
            this.$post('/crm/clientRegisterStep/listByName', params).then(({ data }) => {
                if (data.result && data.code === 'C0000') {
                    cb(data.result)
                }
            })
        },
        handleSelect(val){
            this.formSearch.supplierName = val.Name
        },
        //查询
        inquire(){
            this.$refs.dataForm.validate((valid)=>{
                if(valid){
                    this.loading = true
                    this.formSearch.asyn = true
                    this.$post('/bigdata/spiderStock/query', this.formSearch).then(({ data }) => {
                        if (data.result && data.code === 'C0000') {
                            let type = 'success'
                            if(data.result == '您查询的供应商无数据，请换个供应商试试吧！'){
                                type = 'warning'
                            }
                            this.$confirm(data.result,'温馨提示', {
                                cancelButtonText: '知道了',
                                showConfirmButton: false,
                                type
                            })
                            this.$refs.dataForm.resetFields()
                        }
                    }).finally(() => {
                        this.loading = false
                    })
                }
            })
        },
        jump(){
            this.$router.push('/query-record-list')
        }
    }
}
</script>

<style lang="scss">
    .inventory{
        padding-top: 120px;
        .inventory-banner{
            width: 600px;
            margin: 0 auto;
            .el-form-item{
                margin-bottom: 40px;
            }
            .el-input{
                height: 60px;
            }
            .el-input__wrapper{
                background-color: #fff;
                border: 1px solid #EEEEEE;
                border-radius: 16px;
            }
            svg{
                width: 18px;
            }
            .btn{
                button{
                    width: 100%;
                    height: 60px;
                    font-size: 18px;
                    svg{
                        margin-right: 7px;
                    }
                }
            }
            .word{
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 40px;
                font-size: 16px;
                cursor: pointer;
                .el-icon{
                    margin-left: 9px;
                }
                &:hover{
                    color: #737373;
                }
            }
        }
    }
</style>